import { Severity } from './error-logger.types';
export var OPENER_ERRORS = {
    opener: {
        experimentLoad: {
            id: 1000,
            name: 'opener.experimentLoad',
            severity: Severity.FATAL,
        },
        iframeLoad: {
            id: 1001,
            name: 'opener.iframeLoad',
            severity: Severity.FATAL,
        },
        exposureRequest: {
            id: 1002,
            name: 'opener.exposureRequest',
            severity: Severity.FATAL,
        },
    },
    openerHandlers: {
        layoutMountError: {
            id: 1100,
            name: 'openerHandlers.layoutMountError',
            severity: Severity.FATAL,
        },
        layoutIsReadyHasNoFeedbackWindow: {
            id: 1101,
            name: 'openerHandlers.layoutIsReadyHasNoFeedbackWindow',
            severity: Severity.FATAL,
        },
    },
};
export var CLIENT_ERRORS = {
    feedbackSubmit: {
        submitError: {
            id: 5000,
            name: 'feedbackSubmit.submitError',
            severity: Severity.RECOVERABLE,
        },
    },
    iframeTransport: {
        sendMessage: {
            id: 5100,
            name: 'iframeTransport.sendMessage',
            severity: Severity.FATAL,
        },
    },
    optOut: {
        disableQuestion: {
            id: 5200,
            name: 'optOut.disableQuestion',
            severity: Severity.RECOVERABLE,
        },
    },
    lifecycle: {
        closeWindowFromRoot: {
            id: 5300,
            name: 'lifecycle.closeWindowFromRoot',
            severity: Severity.ERROR,
        },
        noMatchPageWasShown: {
            id: 5301,
            name: 'lifecycle.noMatchPageWasShown',
            severity: Severity.ERROR,
        },
        reactAppCatchError: {
            id: 5302,
            name: 'lifecycle.reactAppCatchError',
            severity: Severity.ERROR,
        },
    },
};
//# sourceMappingURL=errors-dictionary.js.map